const routes = [
  {
    path: '/errors/:status',
    component: () =>
      import(/* webpackChunkName: "ErrorByStatus" */ '@/views/errors/ErrorByStatus.vue'),
  },
]

export default routes
